import React from "react"
import PropTypes from "prop-types"
import { formatDate, parseDate } from "@/utils/dateHelper"
import { startOfDay } from "date-fns"

const OrderCancellationDetails = ({
  cancellationInfo = [],
  i18n: { singleCancelledOrder, multiCancelledOrder } = {},
  cancelledQuantity,
  availableQty,
}) => {
  if (!cancellationInfo.length) return null

  const normalizeDate = date => {
    const parsed = parseDate(date)
    return parsed ? startOfDay(parsed) : null
  }

  const groupedCancellationDate = Object.values(
    cancellationInfo.reduce((acc, { cancelledDate = "", quantity = 0 }) => {
      const normalized = normalizeDate(cancelledDate)
      if (!normalized) return acc // skip invalid dates silently
      const key = formatDate(normalized, "MM/dd/yy")
      if (!acc[key]) {
        acc[key] = {
          cancelledDate: normalized,
          quantity: 0,
        }
      }
      acc[key].quantity += quantity
      return acc
    }, {})
  ).sort((a, b) => b.cancelledDate - a.cancelledDate)

  const isFullyCancelled = cancelledQuantity === availableQty

  if (groupedCancellationDate.length === 1) {
    const { cancelledDate, quantity } = groupedCancellationDate[0]
    return (
      <p>
        {isFullyCancelled
          ? singleCancelledOrder(formatDate(cancelledDate, "MM/dd/yy"))
          : multiCancelledOrder(
              quantity,
              formatDate(cancelledDate, "MM/dd/yy")
            )}
      </p>
    )
  }

  return (
    <>
      {groupedCancellationDate.map(({ cancelledDate, quantity }) => {
        const key = `${cancelledDate?.getTime?.() || ""}-${quantity}`
        return (
          <p key={key}>
            {multiCancelledOrder(
              quantity,
              formatDate(cancelledDate, "MM/dd/yy")
            )}
          </p>
        )
      })}
    </>
  )
}

OrderCancellationDetails.propTypes = {
  cancellationInfo: PropTypes.arrayOf(
    PropTypes.shape({
      cancelledDate: PropTypes.string.isRequired,
      quantity: PropTypes.number.isRequired,
    })
  ),
  cancelledQuantity: PropTypes.number,
  quantity: PropTypes.number,
  i18n: PropTypes.object,
  availableQty: PropTypes.number,
}

export default OrderCancellationDetails
